export const es: Record<string, string> = {
  "udra.availableCountOne": "{count} disponible",
  "udra.assignmentCountsOne": "{recipients} destinatarios · {articles} artículo",

  "udra.outgoingDescription": "Revisa las entregas mensuales y el saldo de cada artículo para {odei} / {type}.",
  "udra.assignmentDescription": "{odei} / {type} · Identifica lo asignado y lo que queda disponible por asignar.",
  "udra.articleCount": "{count} artículos",
  "udra.monthlyCaption": "{title} por mes de {year}. {odei}, {type}.",
  "udra.numberHeading": "N°",
  "udra.viewArticleDetail": "Ver detalle de {name}",
  "udra.articleRange": "{range} de {total} artículos",
  "udra.updatedAt": "Actualizado: {date}",
  "udra.unitsAssignedSummary": "{assigned} de {total} unidades asignadas · {balance}",
  "udra.articleContextSummary": "{unit} · {odei} / {type} · Año: {year}",
  "udra.annualIncomeContext": "Resumen anual de ingresos · {year}",
  "udra.scopeContext": "Contexto: {odei} / {type}",
  "udra.fieldType": "Campo",
  "udra.officeType": "Oficina",
  "udra.selectRecipientsCaption": "{article} · Selecciona personas con cupo disponible.",
  "udra.recipientCount": "{count} destinatarios",
  "udra.selectPerson": "Seleccionar a {name}",
  "udra.availableCount": "{count} disponibles",
  "udra.selectedCount": "{count} seleccionados",
  "udra.selectArticleNamed": "Seleccionar {name}",
  "udra.selectedArticleCount": "{count} artículos seleccionados",
  "udra.movementSaved": "Movimiento {reference} registrado correctamente.",
  "udra.articleIndex": "Artículo {index} *",
  "udra.removeArticleIndex": "Quitar artículo {index}",
  "udra.stockAvailable": "Stock disponible: {stock}",
  "udra.maximumAvailable": "Máximo disponible: {quantity}.",
  "udra.assignmentSaved": "Asignación {reference} registrada correctamente.",
  "udra.removeNamed": "Quitar {name}",
  "udra.individualAvailable": "Disponible para esta persona",
  "udra.removePerson": "Quitar a {name}",
  "udra.decreaseFor": "Reducir cantidad para {name}",
  "udra.quantityFor": "Cantidad para {name}",
  "udra.increaseFor": "Aumentar cantidad para {name}",
  "udra.articleQuantitiesHint": "Cantidades de {article}, en {unit}. Cada persona conserva su disponible individual.",
  "udra.totalExceeded": "La cantidad total ({total}) supera el saldo disponible de {available}.",
  "udra.fileSizeKb": "{size} KB",
  "udra.assignmentCounts": "{recipients} destinatarios · {articles} artículos",
  "udra.drawerHeading": "UDRA / {kind} / DETALLE DEL ARTÍCULO",
  "udra.articleMeta": "{category} · Unidad de medida: {unit}",
  "udra.assignedUnits": "Unidades asignadas",
  "udra.deliveredUnits": "Unidades entregadas",
  "udra.individualAvailabilityContext": "En {odei}, la cantidad disponible también se verifica para cada persona.",
  "udra.assignmentTabCount": "Asignaciones · {count}",
  "udra.dispatchTo": "Salida hacia {odei} / {type}",
  "udra.dateReference": "{date} · Referencia {reference}",

  "udra.incomeTitle": "Ingreso de artículos",
  "udra.outgoingTitle": "Salida de artículos",
  "udra.assignmentTitle": "Asignación de artículos",
  "udra.income": "Ingresos",
  "udra.outgoing": "Salidas",
  "udra.assignment": "Asignación",
  "udra.incomeDescription": "Consulta los ingresos por artículo y mes; registra nuevos movimientos con su sustento.",
  "udra.allArticles": "Todos los artículos",
  "udra.availableBalance": "Con saldo por asignar",
  "udra.unassigned": "Sin asignación",
  "udra.assignmentComplete": "Asignación completa",
  "udra.assignmentPartial": "Asignación parcial",
  "udra.exportSuccess": "El reporte Excel se descargó correctamente.",
  "udra.recordIncome": "Registrar ingreso",
  "udra.recordOutgoing": "Registrar salida",
  "udra.filterAssignmentStatus": "Filtrar por estado de asignación",
  "udra.assignmentStockNote": "* Stock en esta vista = salida − asignado",
  "udra.monthlySummary": "Resumen mensual",
  "udra.searchArticle": "Buscar artículo",
  "udra.filterCategory": "Filtrar por categoría",
  "udra.categoryAll": "Categoría: todas",
  "udra.exportByMonth": "Exportar por meses",
  "udra.loadingMonthly": "Cargando resumen mensual…",
  "udra.noArticles": "No se encontraron artículos",
  "udra.noArticlesPeriodHelp": "Prueba otro período, categoría o término de búsqueda.",
  "udra.clearSearchFilters": "Limpiar búsqueda y filtros",
  "udra.monthlyScrollAria": "Resumen por meses; desplaza horizontalmente para ver todas las columnas",
  "udra.article": "Artículo",
  "udra.unitOfMeasure": "Unidad de medida",
  "udra.annualTotal": "Total anual",
  "udra.assigned": "Asignado",
  "udra.dispatch": "Salida",
  "udra.stockAsterisk": "Stock*",
  "udra.stock": "Stock",
  "udra.detail": "Detalle",
  "udra.quantitiesUnitHint": "Cantidades en la unidad de medida de cada artículo",
  "udra.warehouseStockNote": "Stock = ingresos − salidas",
  "udra.refreshingResults": "Actualizando resultados…",
  "udra.scrollMonthsHint": "Desplaza la tabla para consultar todos los meses y saldos.",
  "udra.previousPage": "Página anterior",
  "udra.nextPage": "Página siguiente",
  "udra.selectedArticleSummary": "Resumen del artículo seleccionado",
  "udra.selectedArticleEyebrow": "ARTÍCULO SELECCIONADO",
  "udra.noAssignmentBalance": "Sin saldo para nuevas asignaciones",
  "udra.assignmentBalanceAvailable": "Saldo disponible para asignar",
  "udra.dispatchUpper": "SALIDA",
  "udra.incomeUpper": "INGRESOS",
  "udra.assignedUpper": "ASIGNADO",
  "udra.outgoingUpper": "SALIDAS",
  "udra.toAssignUpper": "POR ASIGNAR",
  "udra.stockUpper": "STOCK",
  "udra.viewRecipients": "Ver destinatarios",
  "udra.viewMovements": "Ver movimientos",
  "udra.viewMovementsSupport": "Ver movimientos y sustento",
  "udra.detailKeepsContext": "El detalle conserva año, mes, ODEI y tipo",
  "udra.allMonths": "Todos los meses",
  "udra.type": "Tipo",
  "udra.selectRecipients": "Seleccionar destinatarios",
  "udra.searchNameRole": "Buscar por nombre o cargo",
  "udra.searchRecipient": "Buscar destinatario",
  "udra.clearVisibleSelection": "Quitar selección visible",
  "udra.selectAvailable": "Seleccionar disponibles",
  "udra.selectAllAvailable": "Seleccionar todos los destinatarios disponibles",
  "udra.recipient": "Destinatario",
  "udra.quota": "Cupo",
  "udra.available": "Disponible",
  "udra.quotaReached": "Cupo cubierto",
  "udra.noMatchingRecipients": "No hay destinatarios que coincidan con la búsqueda.",
  "udra.applySelection": "Aplicar selección",
  "udra.addArticlesAssignment": "Agregar artículos a la asignación",
  "udra.category": "Categoría",
  "udra.allCategories": "Todas las categorías",
  "udra.searchArticleAssign": "Buscar artículo para asignar",
  "udra.choose": "Elegir",
  "udra.unit": "Unidad",
  "udra.noArticlesPeriod": "No se encontraron artículos.",
  "udra.applyArticles": "Aplicar artículos",
  "udra.recordIncomeTitle": "Registrar ingreso de artículos",
  "udra.recordOutgoingTitle": "Registrar salida de artículos",
  "udra.dateContextError": "La fecha debe corresponder al año y al corte de la consulta.",
  "udra.descriptionMinError": "Escribe una descripción de al menos 3 caracteres.",
  "udra.articleRequiredError": "Selecciona al menos un artículo.",
  "udra.duplicateArticleError": "Un artículo solo puede aparecer una vez en el movimiento.",
  "udra.positiveQuantitiesError": "Las cantidades deben ser números enteros mayores que cero.",
  "udra.checkingStockError": "Espera mientras se verifica el stock de los artículos.",
  "udra.stockExceededError": "Una cantidad supera el stock disponible del artículo.",
  "udra.pdfAttachError": "Adjunta un documento PDF de hasta 5 MB.",
  "udra.loadingArticles": "Cargando artículos…",
  "udra.movementDate": "Fecha del movimiento *",
  "udra.descriptionRequired": "Descripción *",
  "udra.movementReason": "Motivo del movimiento",
  "udra.articlesQuantities": "Artículos y cantidades",
  "udra.addArticle": "Agregar artículo",
  "udra.selectArticle": "Seleccionar artículo",
  "udra.quantityRequired": "Cantidad *",
  "udra.checking": "Consultando…",
  "udra.optionalObservation": "Observación · opcional",
  "udra.movementAdditionalInfo": "Información adicional sobre el movimiento",
  "udra.attachSupportPdf": "Adjuntar sustento PDF",
  "udra.upTo5Mb": "Hasta 5 MB",
  "udra.saving": "Guardando…",
  "udra.saveMovement": "Guardar movimiento",
  "udra.positiveIntegerError": "Indica un entero positivo.",
  "udra.assignmentDateError": "Selecciona una fecha dentro del año y del corte de la consulta.",
  "udra.addArticleError": "Agrega al menos un artículo.",
  "udra.recipientEachArticleError": "Selecciona al menos un destinatario para cada artículo.",
  "udra.reviewQuotasError": "Revisa las cantidades y los cupos individuales señalados.",
  "udra.assignmentBalanceError": "La cantidad a asignar supera el saldo general de un artículo.",
  "udra.articleUnavailableError": "El artículo no admite asignaciones o no tiene saldo disponible en este contexto. Selecciona otro artículo.",
  "udra.pdfSelectError": "Selecciona un archivo PDF de hasta 5 MB.",
  "udra.newAssignmentTitle": "Nueva asignación de artículos",
  "udra.newAssignmentDescription": "Selecciona destinatarios, indica las cantidades y revisa el saldo antes de confirmar.",
  "udra.newAssignmentBreadcrumb": "Asignación / Nuevo registro",
  "udra.loadingArticlesRecipients": "Cargando artículos y destinatarios…",
  "udra.assignmentDetails": "Datos de la asignación",
  "udra.assignmentDate": "Fecha de asignación *",
  "udra.assignmentDateFieldError": "La fecha debe pertenecer al año y al corte seleccionados.",
  "udra.assignmentDescriptionPlaceholder": "Entrega de artículos al equipo de campo",
  "udra.originContextHint": "ODEI, tipo y año se mantienen desde la consulta de origen.",
  "udra.articlesRecipients": "Artículos y destinatarios",
  "udra.selectedArticles": "Artículos seleccionados",
  "udra.noSelectedArticles": "Ningún artículo seleccionado",
  "udra.addArticles": "Agregar artículos",
  "udra.articleRecipientsHint": "Selecciona un artículo para editar sus destinatarios. Cada artículo conserva su selección y cantidades.",
  "udra.searchSelectedRecipients": "Buscar en los destinatarios seleccionados",
  "udra.searchAmongSelectedRecipients": "Buscar entre los destinatarios seleccionados",
  "udra.selected": "Seleccionado",
  "udra.toAssign": "A asignar",
  "udra.remainingBalance": "Saldo posterior",
  "udra.noMatches": "No hay coincidencias",
  "udra.selectArticleRecipients": "Selecciona los destinatarios de este artículo",
  "udra.tryNameRole": "Prueba otro nombre o cargo.",
  "udra.recipientQuotaHint": "Se mostrará el cupo individual antes de registrar la entrega.",
  "udra.addArticleRecipientsHint": "Agrega un artículo para consultar su saldo y seleccionar destinatarios.",
  "udra.supportingDocuments": "Sustento del registro",
  "udra.deliveryObservationPlaceholder": "Añadir una observación sobre la entrega…",
  "udra.optionalDocument": "Documento · opcional",
  "udra.attachPdf": "Adjuntar PDF",
  "udra.oneFile5Mb": "1 archivo · Hasta 5 MB",
  "udra.attachSupportPdfAria": "Adjuntar documento PDF de sustento",
  "udra.beforeConfirm": "Antes de confirmar",
  "udra.assignmentReview": "Revisión de la asignación",
  "udra.currentOverallBalance": "Saldo general actual",
  "udra.quantityToAssign": "Cantidad a asignar",
  "udra.overallBalanceAfter": "Saldo general después",
  "udra.summaryAfterAdding": "El resumen aparecerá al agregar artículos.",
  "udra.saveBalanceHint": "Cada persona conserva su cupo individual. El saldo se verifica nuevamente al guardar.",
  "udra.saveChecks": "Comprobaciones al guardar",
  "udra.positiveWholeQuantities": "Cantidades enteras y positivas",
  "udra.sufficientIndividualBalances": "Disponibles individuales suficientes",
  "udra.dateRecipientsSelected": "Fecha y destinatarios seleccionados",
  "udra.assignmentReady": "Todo listo para confirmar la asignación.",
  "udra.reviewRecipientsBeforeConfirm": "Revisa el destinatario y su cantidad antes de confirmar.",
  "udra.assignmentIncludesHint": "La asignación incluirá los destinatarios y las cantidades indicadas.",
  "udra.savingAssignment": "Guardando asignación…",
  "udra.confirmAssignment": "Confirmar asignación",
  "udra.dispatchToScope": "Salida al ámbito",
  "udra.remainingToAssign": "Por asignar",
  "udra.closeDetail": "Cerrar detalle",
  "udra.loadingArticleDetail": "Cargando detalle del artículo…",
  "udra.contextPreserved": "Contexto conservado",
  "udra.assignmentBalance": "Saldo para asignación",
  "udra.articleBalance": "Saldo del artículo",
  "udra.registeredUnits": "Unidades registradas",
  "udra.scopeOverallBalance": "Saldo general del ámbito",
  "udra.viewSelectedMovementsHint": "Consulta los movimientos y sus documentos de sustento en el contexto seleccionado.",
  "udra.articleDetail": "Detalle del artículo",
  "udra.movements": "Movimientos",
  "udra.balanceOrigin": "Consultar el origen del saldo",
  "udra.noMovements": "No hay movimientos registrados en este contexto.",
  "udra.viewSupportPdf": "Ver sustento PDF",
  "udra.noAttachment": "Sin documento adjunto.",
  "udra.unitsLower": "unidades",
  "udra.hideDetail": "Ocultar detalle",
  "udra.viewMovement": "Ver movimiento",
  "udra.noAssignmentsCutoff": "Sin asignaciones registradas en el corte",
  "udra.newAssignmentRecipientsHint": "La nueva asignación identificará destinatarios y cantidades por artículo.",
  "udra.recipientAvailability": "Disponibilidad por destinatario",
  "udra.noRecipientsScope": "Sin destinatarios en este ámbito.",
  "udra.beforeAssign": "Antes de asignar",
  "udra.selectAvailableRecipientsHint": "Selecciona destinatarios con saldo disponible para este artículo.",
  "udra.noNewAssignmentBalance": "Este artículo no tiene saldo para nuevas asignaciones en el ámbito seleccionado.",
  "udra.reviewQuantitiesSupport": "Revisa las cantidades y, si corresponde, adjunta el sustento.",
  "udra.newAssignment": "Nueva asignación",
  "udra.detailContextHint": "El detalle conserva el año, mes, ODEI y tipo de la consulta.",
}

export const en: Record<string, string> = {
  "udra.availableCountOne": "{count} available",
  "udra.assignmentCountsOne": "{recipients} recipients · {articles} article",

  "udra.outgoingDescription": "Review monthly deliveries and each article’s balance for {odei} / {type}.",
  "udra.assignmentDescription": "{odei} / {type} · See what has been assigned and what remains available.",
  "udra.articleCount": "{count} articles",
  "udra.monthlyCaption": "{title} by month for {year}. {odei}, {type}.",
  "udra.numberHeading": "No.",
  "udra.viewArticleDetail": "View details for {name}",
  "udra.articleRange": "{range} of {total} articles",
  "udra.updatedAt": "Updated: {date}",
  "udra.unitsAssignedSummary": "{assigned} of {total} units assigned · {balance}",
  "udra.articleContextSummary": "{unit} · {odei} / {type} · Year: {year}",
  "udra.annualIncomeContext": "Annual receipts summary · {year}",
  "udra.scopeContext": "Context: {odei} / {type}",
  "udra.fieldType": "Field",
  "udra.officeType": "Office",
  "udra.selectRecipientsCaption": "{article} · Select people with available capacity.",
  "udra.recipientCount": "{count} recipients",
  "udra.selectPerson": "Select {name}",
  "udra.availableCount": "{count} available",
  "udra.selectedCount": "{count} selected",
  "udra.selectArticleNamed": "Select {name}",
  "udra.selectedArticleCount": "{count} articles selected",
  "udra.movementSaved": "Transaction {reference} recorded successfully.",
  "udra.articleIndex": "Article {index} *",
  "udra.removeArticleIndex": "Remove article {index}",
  "udra.stockAvailable": "Available stock: {stock}",
  "udra.maximumAvailable": "Maximum available: {quantity}.",
  "udra.assignmentSaved": "Assignment {reference} recorded successfully.",
  "udra.removeNamed": "Remove {name}",
  "udra.individualAvailable": "Available to this person",
  "udra.removePerson": "Remove {name}",
  "udra.decreaseFor": "Decrease quantity for {name}",
  "udra.quantityFor": "Quantity for {name}",
  "udra.increaseFor": "Increase quantity for {name}",
  "udra.articleQuantitiesHint": "Quantities for {article}, in {unit}. Each person retains their individual availability.",
  "udra.totalExceeded": "The total quantity ({total}) exceeds the available balance of {available}.",
  "udra.fileSizeKb": "{size} KB",
  "udra.assignmentCounts": "{recipients} recipients · {articles} articles",
  "udra.drawerHeading": "UDRA / {kind} / ARTICLE DETAILS",
  "udra.articleMeta": "{category} · Unit of measure: {unit}",
  "udra.assignedUnits": "Units assigned",
  "udra.deliveredUnits": "Units delivered",
  "udra.individualAvailabilityContext": "In {odei}, the available quantity is also checked for each person.",
  "udra.assignmentTabCount": "Assignments · {count}",
  "udra.dispatchTo": "Dispatched to {odei} / {type}",
  "udra.dateReference": "{date} · Reference {reference}",

  "udra.incomeTitle": "Article receipts",
  "udra.outgoingTitle": "Article dispatches",
  "udra.assignmentTitle": "Article assignments",
  "udra.income": "Receipts",
  "udra.outgoing": "Dispatches",
  "udra.assignment": "Assignment",
  "udra.incomeDescription": "Review receipts by article and month, and record new transactions with supporting documents.",
  "udra.allArticles": "All articles",
  "udra.availableBalance": "Available for assignment",
  "udra.unassigned": "Unassigned",
  "udra.assignmentComplete": "Fully assigned",
  "udra.assignmentPartial": "Partially assigned",
  "udra.exportSuccess": "The Excel report was downloaded successfully.",
  "udra.recordIncome": "Record receipt",
  "udra.recordOutgoing": "Record dispatch",
  "udra.filterAssignmentStatus": "Filter by assignment status",
  "udra.assignmentStockNote": "* Stock in this view = dispatched − assigned",
  "udra.monthlySummary": "Monthly summary",
  "udra.searchArticle": "Search articles",
  "udra.filterCategory": "Filter by category",
  "udra.categoryAll": "Category: all",
  "udra.exportByMonth": "Export by month",
  "udra.loadingMonthly": "Loading monthly summary…",
  "udra.noArticles": "No articles found",
  "udra.noArticlesPeriodHelp": "Try a different period, category, or search term.",
  "udra.clearSearchFilters": "Clear search and filters",
  "udra.monthlyScrollAria": "Monthly summary; scroll horizontally to see all columns",
  "udra.article": "Article",
  "udra.unitOfMeasure": "Unit of measure",
  "udra.annualTotal": "Annual total",
  "udra.assigned": "Assigned",
  "udra.dispatch": "Dispatched",
  "udra.stockAsterisk": "Stock*",
  "udra.stock": "Stock",
  "udra.detail": "Details",
  "udra.quantitiesUnitHint": "Quantities in each article’s unit of measure",
  "udra.warehouseStockNote": "Stock = receipts − dispatches",
  "udra.refreshingResults": "Updating results…",
  "udra.scrollMonthsHint": "Scroll the table to view all months and balances.",
  "udra.previousPage": "Previous page",
  "udra.nextPage": "Next page",
  "udra.selectedArticleSummary": "Selected article summary",
  "udra.selectedArticleEyebrow": "SELECTED ARTICLE",
  "udra.noAssignmentBalance": "No balance available for new assignments",
  "udra.assignmentBalanceAvailable": "Balance available for assignment",
  "udra.dispatchUpper": "DISPATCHED",
  "udra.incomeUpper": "RECEIPTS",
  "udra.assignedUpper": "ASSIGNED",
  "udra.outgoingUpper": "DISPATCHES",
  "udra.toAssignUpper": "TO ASSIGN",
  "udra.stockUpper": "STOCK",
  "udra.viewRecipients": "View recipients",
  "udra.viewMovements": "View transactions",
  "udra.viewMovementsSupport": "View transactions and documents",
  "udra.detailKeepsContext": "Details retain the year, month, ODEI, and type",
  "udra.allMonths": "All months",
  "udra.type": "Type",
  "udra.selectRecipients": "Select recipients",
  "udra.searchNameRole": "Search by name or role",
  "udra.searchRecipient": "Search recipients",
  "udra.clearVisibleSelection": "Clear visible selection",
  "udra.selectAvailable": "Select available recipients",
  "udra.selectAllAvailable": "Select all available recipients",
  "udra.recipient": "Recipient",
  "udra.quota": "Quota",
  "udra.available": "Available",
  "udra.quotaReached": "Quota reached",
  "udra.noMatchingRecipients": "No recipients match your search.",
  "udra.applySelection": "Apply selection",
  "udra.addArticlesAssignment": "Add articles to the assignment",
  "udra.category": "Category",
  "udra.allCategories": "All categories",
  "udra.searchArticleAssign": "Search for an article to assign",
  "udra.choose": "Select",
  "udra.unit": "Unit",
  "udra.noArticlesPeriod": "No articles found.",
  "udra.applyArticles": "Apply articles",
  "udra.recordIncomeTitle": "Record article receipt",
  "udra.recordOutgoingTitle": "Record article dispatch",
  "udra.dateContextError": "The date must fall within the report year and cutoff.",
  "udra.descriptionMinError": "Enter a description of at least 3 characters.",
  "udra.articleRequiredError": "Select at least one article.",
  "udra.duplicateArticleError": "Each article can appear only once in a transaction.",
  "udra.positiveQuantitiesError": "Quantities must be positive whole numbers.",
  "udra.checkingStockError": "Please wait while article stock is checked.",
  "udra.stockExceededError": "A quantity exceeds the article’s available stock.",
  "udra.pdfAttachError": "Attach a PDF document up to 5 MB.",
  "udra.loadingArticles": "Loading articles…",
  "udra.movementDate": "Transaction date *",
  "udra.descriptionRequired": "Description *",
  "udra.movementReason": "Reason for the transaction",
  "udra.articlesQuantities": "Articles and quantities",
  "udra.addArticle": "Add article",
  "udra.selectArticle": "Select article",
  "udra.quantityRequired": "Quantity *",
  "udra.checking": "Checking…",
  "udra.optionalObservation": "Notes · optional",
  "udra.movementAdditionalInfo": "Additional information about the transaction",
  "udra.attachSupportPdf": "Attach supporting PDF",
  "udra.upTo5Mb": "Up to 5 MB",
  "udra.saving": "Saving…",
  "udra.saveMovement": "Save transaction",
  "udra.positiveIntegerError": "Enter a positive whole number.",
  "udra.assignmentDateError": "Select a date within the report year and cutoff.",
  "udra.addArticleError": "Add at least one article.",
  "udra.recipientEachArticleError": "Select at least one recipient for each article.",
  "udra.reviewQuotasError": "Review the highlighted quantities and individual quotas.",
  "udra.assignmentBalanceError": "The quantity to assign exceeds an article’s overall balance.",
  "udra.articleUnavailableError": "This article cannot be assigned or has no available balance in this context. Select another article.",
  "udra.pdfSelectError": "Select a PDF file up to 5 MB.",
  "udra.newAssignmentTitle": "New article assignment",
  "udra.newAssignmentDescription": "Select recipients, enter quantities, and review the balance before confirming.",
  "udra.newAssignmentBreadcrumb": "Assignment / New record",
  "udra.loadingArticlesRecipients": "Loading articles and recipients…",
  "udra.assignmentDetails": "Assignment details",
  "udra.assignmentDate": "Assignment date *",
  "udra.assignmentDateFieldError": "The date must fall within the selected year and cutoff.",
  "udra.assignmentDescriptionPlaceholder": "Articles delivered to the field team",
  "udra.originContextHint": "ODEI, type, and year are retained from the original report.",
  "udra.articlesRecipients": "Articles and recipients",
  "udra.selectedArticles": "Selected articles",
  "udra.noSelectedArticles": "No articles selected",
  "udra.addArticles": "Add articles",
  "udra.articleRecipientsHint": "Select an article to edit its recipients. Each article retains its selection and quantities.",
  "udra.searchSelectedRecipients": "Search selected recipients",
  "udra.searchAmongSelectedRecipients": "Search among selected recipients",
  "udra.selected": "Selected",
  "udra.toAssign": "To assign",
  "udra.remainingBalance": "Remaining balance",
  "udra.noMatches": "No matches",
  "udra.selectArticleRecipients": "Select recipients for this article",
  "udra.tryNameRole": "Try another name or role.",
  "udra.recipientQuotaHint": "The individual quota will be shown before recording the delivery.",
  "udra.addArticleRecipientsHint": "Add an article to view its balance and select recipients.",
  "udra.supportingDocuments": "Supporting information",
  "udra.deliveryObservationPlaceholder": "Add a note about the delivery…",
  "udra.optionalDocument": "Document · optional",
  "udra.attachPdf": "Attach PDF",
  "udra.oneFile5Mb": "1 file · Up to 5 MB",
  "udra.attachSupportPdfAria": "Attach a supporting PDF document",
  "udra.beforeConfirm": "Before confirming",
  "udra.assignmentReview": "Assignment review",
  "udra.currentOverallBalance": "Current overall balance",
  "udra.quantityToAssign": "Quantity to assign",
  "udra.overallBalanceAfter": "Overall balance afterward",
  "udra.summaryAfterAdding": "The summary will appear when you add articles.",
  "udra.saveBalanceHint": "Each person retains their individual quota. The balance is checked again when saving.",
  "udra.saveChecks": "Checks when saving",
  "udra.positiveWholeQuantities": "Positive whole-number quantities",
  "udra.sufficientIndividualBalances": "Sufficient individual availability",
  "udra.dateRecipientsSelected": "Date and recipients selected",
  "udra.assignmentReady": "Ready to confirm the assignment.",
  "udra.reviewRecipientsBeforeConfirm": "Review each recipient and their quantity before confirming.",
  "udra.assignmentIncludesHint": "The assignment will include the specified recipients and quantities.",
  "udra.savingAssignment": "Saving assignment…",
  "udra.confirmAssignment": "Confirm assignment",
  "udra.dispatchToScope": "Dispatched to scope",
  "udra.remainingToAssign": "To assign",
  "udra.closeDetail": "Close details",
  "udra.loadingArticleDetail": "Loading article details…",
  "udra.contextPreserved": "Context retained",
  "udra.assignmentBalance": "Assignment balance",
  "udra.articleBalance": "Article balance",
  "udra.registeredUnits": "Units recorded",
  "udra.scopeOverallBalance": "Overall balance in this scope",
  "udra.viewSelectedMovementsHint": "Review transactions and their supporting documents in the selected context.",
  "udra.articleDetail": "Article details",
  "udra.movements": "Transactions",
  "udra.balanceOrigin": "View the source of the balance",
  "udra.noMovements": "No transactions have been recorded in this context.",
  "udra.viewSupportPdf": "View supporting PDF",
  "udra.noAttachment": "No document attached.",
  "udra.unitsLower": "units",
  "udra.hideDetail": "Hide details",
  "udra.viewMovement": "View transaction",
  "udra.noAssignmentsCutoff": "No assignments recorded by this cutoff",
  "udra.newAssignmentRecipientsHint": "The new assignment will specify recipients and quantities for each article.",
  "udra.recipientAvailability": "Availability by recipient",
  "udra.noRecipientsScope": "No recipients in this scope.",
  "udra.beforeAssign": "Before assigning",
  "udra.selectAvailableRecipientsHint": "Select recipients with available capacity for this article.",
  "udra.noNewAssignmentBalance": "This article has no balance available for new assignments in the selected scope.",
  "udra.reviewQuantitiesSupport": "Review the quantities and attach supporting documents if applicable.",
  "udra.newAssignment": "New assignment",
  "udra.detailContextHint": "Details retain the report year, month, ODEI, and type.",
}

